var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarEM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.87 94.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#007fc0;}.cls-2{fill:#82d2ed;}.cls-3{fill:#f2e6d3;}.cls-4{fill:#e5d1ba;}.cls-5{fill:#dbbfa1;}.cls-6{fill:#664d42;}.cls-7{fill:#876857;}.cls-8{fill:#75594b;}.cls-9{fill:#f4f0d3;}.cls-10{fill:#91d8f0;}.cls-11{fill:#c8ecf8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.43,
    cy: 47.43,
    r: 47.43
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.43 66.01 52.29 66.02 52.29 68.63 54.43 66.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.72 66.01 44.94 66.02 44.94 68.47 42.72 66.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "37.3 64.31 30.08 53.16 29.78 29.77 29.78 15.49 33.05 12.73 48.71 22.32 64.24 12.73 67.42 16.31 67.21 53.18 59.9 64.31 37.3 64.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "67.42 16.31 65.65 14.32 59 17.5 63.67 30.55 48.71 34.3 48.71 49.36 63.59 53.09 63.59 53.09 63.67 30.55 67.41 34.41 67.42 16.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "67.42 19.26 63.67 30.55 63.59 53.09 67.41 53.18 67.41 34.41 67.42 19.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.29,41.82l1.94-19.65-4.46-12L59.88,6,53.5,6,48.71,9,43.92,6h0L37.55,6,30.66,10.2l-4.45,12,1.93,19.65L25.49,48l4.29,5.18L37.3,64.51H59.89l7.52-11.33L71.94,48Zm-26,13.29,2.32-3.38H51.7l2.75,3.38Zm24.16-20.7L63,50.6l-4.07,4v0h0l-5.28-6.5H43.52l-4.67,6.51-4.61-4-4.46-16.1v-2.7L33.93,16.9l0,0,14.75,5.45,14.74-5.43h0l4,14.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "48.71 9.02 53.5 5.99 63.48 16.88 48.71 22.32 48.71 9.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "43.92 5.99 37.55 6.01 30.66 10.2 26.21 22.17 29.78 31.81 33.93 16.9 43.92 5.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "53.5 5.99 59.88 6.01 66.77 10.2 71.23 22.17 67.41 31.81 63.45 16.9 53.5 5.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "29.78 53.16 25.49 47.98 28.14 41.82 26.21 22.17 29.78 31.81 29.78 53.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "48.71 9.02 43.92 5.99 33.95 16.88 48.71 22.32 48.71 9.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M58.93,54.65l-5.28-6.5H43.52l-4.67,6.51-4.61-4-4.5-16.24,0,18.79L37.3,64.51H59.89Zm-15.68.46,2.32-3.38H51.7l2.75,3.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "58.93 54.67 53.65 48.15 48.71 48.15 48.71 51.73 51.7 51.73 54.45 55.11 48.71 55.11 48.71 64.52 59.9 64.52 58.93 54.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "52.29 74.35 48.52 76.94 44.93 74.35 44.93 64.52 52.29 64.52 52.29 74.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "52.29 72.36 44.93 65.64 52.29 65.64 52.29 72.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 44.93,
    y: 64.51,
    width: 7.36,
    height: 1.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M68.92,89.73l.79-16.6L52.26,68.2l-3.78,6.86.23,19.78A47.07,47.07,0,0,0,68.92,89.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.46,92.77l-.74-18.6-5.64-1,1.41,17.8A49.14,49.14,0,0,0,33.46,92.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "48.56 71.66 55.47 77.88 57.03 69.37 54.43 66.01 48.56 71.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "55.51 77.88 48.56 71.66 48.56 75.04 55.51 77.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "48.56 71.66 41.67 77.88 40.02 69.37 42.72 66.01 48.56 71.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "41.7 77.88 48.56 71.66 48.56 75.04 41.7 77.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M33.58,92.8V71.25l-6.5,1.62.38,17.59A46,46,0,0,0,33.58,92.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M32,92.3a47.32,47.32,0,0,0,15.41,2.58c.38,0,.75,0,1.13,0V71.66l-4.88-3.9L40,69.37l-12.94,3.5,2.39,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M70.25,89,70,72.76,57,69.37l-3.71-1.61-4.76,3.9V94.85A47.19,47.19,0,0,0,70.25,89Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarEM);
export default __webpack_public_path__ + "static/media/avatar-e-m.ed500b641abd97d4e33439f4bf005fd2.svg";
export { ForwardRef as ReactComponent };